// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3m18E","tab":"ProcedureTabs_tab__3i-Nu"};